import { searchTextInString } from '@agentguru/helpers';
export var readAgenciesSearch = {
    read: function (_, _a) {
        var readField = _a.readField, args = _a.args;
        var input = (args || {}).input;
        var agencies = readField('readAgencies');
        return agencies === null || agencies === void 0 ? void 0 : agencies.filter(function (agencyRef) {
            var fieldsToSearch = [
                readField('name', agencyRef),
                readField('id', agencyRef),
            ].join('-');
            var match = searchTextInString(input, fieldsToSearch);
            return match;
        });
    },
};
